import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Divider, Input, Form, Radio, RadioChangeEvent, Checkbox } from "antd";
import { CloseCircleOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";
import "./NewSupplierForm.css";

export interface NewSupplierFormProps {
  showForm: boolean;
  closeForm: () => void;
  editSupplierData: any;
  postSupplier: (supplierInfo: any) => void;
  putSupplier?: (supplierInfo: any) => void;
}

const NewSupplierForm = (props: NewSupplierFormProps) => {
  const [supplierInfo, setSupplierInfo] = useState({
    name: "",
    companyName: "",
    identificationCardNumber: "",
    contactNumber: "",
    emailAddress: "",
    address: "",
    companyCode: "",
    passportNumber: "",
    pgOffice: false,
    bwOffice: false,
  });
  const [nameFormStatus, setNameFormStatus] = useState("") as any;
  const [nameFormMessage, setNameFormMessage] = useState("");
  const [companyNameFormStatus, setCompanyNameFormStatus] = useState("") as any;
  const [companyNameFormMessage, setCompanyNameFormMessage] = useState("");
  const [identificationCardNumberFormStatus, setIdentificationCardNumberFormStatus] = useState("") as any;
  const [identificationCardNumberFormMessage, setIdentificationCardNumberFormMessage] = useState("");
  const [passportFormStatus, setPassportFormStatus] = useState("") as any;
  const [passportFormMessage, setPassportFormMessage] = useState("");
  const [officeFormStatus, setOfficeFormStatus] = useState("") as any;
  const [officeFormMessage, setOfficeFormMessage] = useState("");
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  useEffect(() => {
    console.log("run");
    if (props.editSupplierData !== null) {
      setSupplierInfo(props.editSupplierData);
    }
  }, [props.editSupplierData]);

  const updateName = (value: any) => {
    setNameFormStatus("");
    setNameFormMessage("");
    let supplier = { ...supplierInfo };
    supplier.name = value;
    setSupplierInfo(supplier);
  };

  const updateCompanyName = (value: any) => {
    setCompanyNameFormStatus("");
    setCompanyNameFormMessage("");
    let supplier = { ...supplierInfo };
    supplier.companyName = value;
    setSupplierInfo(supplier);
  };

  const updateIdentificationCardNumber = (value: any) => {
    setIdentificationCardNumberFormStatus("");
    setIdentificationCardNumberFormMessage("");
    let supplier = { ...supplierInfo };
    supplier.identificationCardNumber = value;
    setSupplierInfo(supplier);
  };

  const updatePassportNumber = (value: any) => {
    let supplier = { ...supplierInfo };
    supplier.passportNumber = value;
    setSupplierInfo(supplier);
  };

  const updateContactNumber = (value: any) => {
    let supplier = { ...supplierInfo };
    supplier.contactNumber = value;
    setSupplierInfo(supplier);
  };

  const updateEmailAddress = (value: any) => {
    let supplier = { ...supplierInfo };
    supplier.emailAddress = value;
    setSupplierInfo(supplier);
  };

  const updateAddress = (value: any) => {
    let supplier = { ...supplierInfo };
    supplier.address = value;
    setSupplierInfo(supplier);
  };

  const updateCompanyCode = (value: any) => {
    let supplier = { ...supplierInfo };
    supplier.companyCode = value;
    setSupplierInfo(supplier);
  };

  const updateOffice = (checkedValues: any[]) => {
    setOfficeFormStatus("");
    setOfficeFormMessage("");
    let supplier = { ...supplierInfo };
    supplier.bwOffice = checkedValues.includes("Butterworth ( BW )") ? true : false;
    supplier.pgOffice = checkedValues.includes("Penang ( PG )") ? true : false;
    setSupplierInfo(supplier);
  };

  const closeForm = () => {
    resetSupplierInfo();
    props.closeForm();
  };

  const validateForm = () => {
    let supplier = { ...supplierInfo };
    let validationFormStatus = true;
    if (supplier.name === "") {
      validationFormStatus = false;
      setNameFormStatus("error");
      setNameFormMessage("Name must be entered");
    }
    const formatICNumber = supplier.identificationCardNumber.replaceAll(" ", "").replaceAll("-", "");
    if (formatICNumber === "") {
      setIdentificationCardNumberFormStatus("");
      setIdentificationCardNumberFormMessage("");
    } else if (formatICNumber.length > 0 && formatICNumber.length !== 12) {
      validationFormStatus = false;
      setIdentificationCardNumberFormStatus("error");
      setIdentificationCardNumberFormMessage("IC must be 12 numbers");
    }
    if (supplier.pgOffice === false && supplier.bwOffice === false) {
      validationFormStatus = false;
      setOfficeFormStatus("error");
      setOfficeFormMessage("Select at least one office");
    }
    return validationFormStatus;
  };

  const openCancelSupplierModal = () => {
    setIsCancelModalOpen(true);
  };

  const confirmCancelSupplier = () => {
    resetSupplierInfo();
    setIsCancelModalOpen(false);
    closeForm();
  };

  const declineCancelSupplier = () => {
    setIsCancelModalOpen(false);
  };

  const resetSupplierInfo = () => {
    setSupplierInfo({
      name: "",
      companyName: "",
      identificationCardNumber: "",
      contactNumber: "",
      emailAddress: "",
      address: "",
      companyCode: "",
      passportNumber: "",
      pgOffice: false,
      bwOffice: false,
    });
    setNameFormStatus("");
    setNameFormMessage("");
    setCompanyNameFormStatus("");
    setCompanyNameFormMessage("");
    setIdentificationCardNumberFormStatus("");
    setIdentificationCardNumberFormMessage("");
    setOfficeFormStatus("");
    setOfficeFormMessage("");
  };

  const saveSupplierInfo = () => {
    props.putSupplier && props.putSupplier(supplierInfo);
    closeForm();
  };

  const addSupplierInfo = () => {
    props.postSupplier(supplierInfo);
    closeForm();
  };

  const getDefaultCheckboxValue = () => {
    let checkboxValue = [""];
    if (props.editSupplierData !== null && props.editSupplierData.pgOffice) checkboxValue.push("Penang ( PG )");
    if (props.editSupplierData !== null && props.editSupplierData.bwOffice) checkboxValue.push("Butterworth ( BW )");
    return checkboxValue;
  };

  return props.showForm ? (
    <Row justify="center">
      <div className="new-supplier-form">
        <Row>
          <Col span={20}>
            <Row justify="start">New Supplier</Row>
          </Col>
          <Col span={4}>
            <Row justify="end">
              <CloseCircleOutlined onClick={() => openCancelSupplierModal()} />
            </Row>
          </Col>
        </Row>
        <Row>
          <Divider style={{ margin: "12px 0" }} />
        </Row>
        <Form layout="vertical">
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="supplier-form-label">Full Name</label>}
                  validateStatus={nameFormStatus}
                  help={nameFormMessage}
                  style={{ width: "100%" }}
                >
                  <Input
                    placeholder="Name"
                    style={{ width: "100%", marginBottom: "10px", marginRight: "5px" }}
                    value={supplierInfo.name}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateName(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="supplier-form-label">Company Name</label>}
                  style={{ width: "100%" }}
                >
                  <Input
                    placeholder="Company Name"
                    style={{ width: "100%", marginBottom: "10px", marginRight: "5px" }}
                    value={supplierInfo.companyName}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateCompanyName(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="supplier-form-label">Identification Number (IC Number)</label>}
                  validateStatus={identificationCardNumberFormStatus}
                  help={identificationCardNumberFormMessage}
                  style={{ width: "100%" }}
                >
                  <Input
                    placeholder="000000-00-0000"
                    style={{ width: "100%", marginBottom: "10px", marginRight: "5px" }}
                    value={supplierInfo.identificationCardNumber}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateIdentificationCardNumber(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="supplier-form-label">Passport Number</label>}
                  style={{ width: "100%" }}
                >
                  <Input
                    placeholder="Passport Number"
                    style={{ width: "100%", marginBottom: "10px", marginRight: "5px" }}
                    value={supplierInfo.passportNumber}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updatePassportNumber(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="supplier-form-label">Select Office</label>}
                  validateStatus={officeFormStatus}
                  help={officeFormMessage}
                >
                  <Checkbox.Group
                    options={["Butterworth ( BW )", "Penang ( PG )"]}
                    defaultValue={getDefaultCheckboxValue()}
                    // defaultValue={["Butterworth ( BW )", "Penang ( PG )"]}
                    onChange={updateOffice}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          {/* <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="supplier-form-label">Phone Number</label>}
                  //   validateStatus={wasteWeightFormStatus}
                  //   help={wasteWeightFormMessage}
                >
                  <Input
                    placeholder="0.0"
                    style={{ width: "150px", marginBottom: "10px", marginRight: "5px" }}
                    // value={materialInfo.wasteWeight}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateContactNumber(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="supplier-form-label">Email Address</label>}
                  //   validateStatus={wasteWeightFormStatus}
                  //   help={wasteWeightFormMessage}
                >
                  <Input
                    placeholder="0.0"
                    style={{ width: "150px", marginBottom: "10px", marginRight: "5px" }}
                    // value={materialInfo.wasteWeight}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateEmailAddress(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="supplier-form-label">Address</label>}
                  //   validateStatus={wasteWeightFormStatus}
                  //   help={wasteWeightFormMessage}
                >
                  <Input
                    placeholder="0.0"
                    style={{ width: "150px", marginBottom: "10px", marginRight: "5px" }}
                    // value={materialInfo.wasteWeight}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateAddress(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="supplier-form-label">Company Code</label>}
                  //   validateStatus={wasteWeightFormStatus}
                  //   help={wasteWeightFormMessage}
                >
                  <Input
                    placeholder="0.0"
                    style={{ width: "150px", marginBottom: "10px", marginRight: "5px" }}
                    // value={materialInfo.wasteWeight}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateCompanyCode(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row> */}
        </Form>
        <Row justify="center" style={{ marginTop: "20px" }}>
          <Button className="cancel-button" onClick={() => openCancelSupplierModal()}>
            Cancel
          </Button>
          <Button
            type="primary"
            icon={props.editSupplierData ? <SaveOutlined /> : <PlusOutlined />}
            onClick={() =>
              props.editSupplierData ? validateForm() && saveSupplierInfo() : validateForm() && addSupplierInfo()
            }
          >
            {props.editSupplierData ? "Save" : "Add Supplier"}
          </Button>
        </Row>
      </div>
      <Modal
        title="Cancel Supplier Add"
        open={isCancelModalOpen}
        okText="Confirm"
        okType="danger"
        onOk={confirmCancelSupplier}
        onCancel={declineCancelSupplier}
      >
        <p>Are you sure you want to cancel?</p>
        <p>Your changes will not be saved.</p>
      </Modal>
    </Row>
  ) : null;
};

export default NewSupplierForm;
